"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _ = require("lodash");
exports.InputCalendarComponent = (props) => {
    const { selectedItem, id, start_date, end_date, readOnlyStartDate, readOnlyEndDate, minStartDate, setItem, startDateLabel, endDateLabel, minEndDate, maxStartDate, requiredStartDate, requiredEndDate } = props;
    const handleChange = (e) => {
        const name = e.target.id.split("_");
        let itemClone = _.cloneDeep(selectedItem);
        if (name[0] === "startDate") {
            if (itemClone.hasOwnProperty("attributes"))
                itemClone.attributes.start_date = e.target.value;
            else
                itemClone.start_date = e.target.value;
        }
        else {
            if (itemClone.hasOwnProperty("attributes"))
                itemClone.attributes.end_date = e.target.value;
            else
                itemClone.end_date = e.target.value;
        }
        setItem(itemClone, true);
    };
    return (React.createElement("div", { className: "form-row" },
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: 'form-group' },
                React.createElement("label", null,
                    React.createElement("strong", null, startDateLabel),
                    requiredStartDate ? requiredStartDate : React.createElement(React.Fragment, null)),
                React.createElement("input", { className: "form-control", id: `startDate_${id}`, name: `startDate_${id}`, type: "date", onChange: handleChange, value: start_date, "data-date": "06/20/2021", "data-date-format": "MM/DD/YYYY", readOnly: readOnlyStartDate, min: minStartDate, max: maxStartDate }))),
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: 'form-group' },
                React.createElement("label", null,
                    React.createElement("strong", null,
                        endDateLabel,
                        requiredEndDate ? requiredEndDate : React.createElement(React.Fragment, null))),
                React.createElement("input", { className: "form-control", id: `endDate_${id}`, name: `endDate_${id}`, type: "date", placeholder: "MM/DD/YYYY", onChange: handleChange, value: end_date, readOnly: readOnlyEndDate, min: minEndDate })))));
};
//# sourceMappingURL=InputCalendarComponent.js.map